import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import httpClient, { API_URL } from "../../../services/httpClient";
import { downloadFile } from "../../../services/download";
import { getIconForSingleFile } from "../../../services/iconUtils";
import deleteButtonIcon from "../../../media/delete-button.svg";
import { useAuth } from "../../../AuthContext";
import BenefitDocumentsList from "./../../../components/BenefitDocumentsList";

const Multisport = () => {
  const { t } = useTranslation();
  const { userData } = useAuth();

  // Funkcja sprawdzająca uprawnienia admina
  const isAdmin = (userData) => {
    return (
      userData?.userRole === "admin" || userData?.userRole === "hr-manager"
    );
  };

  // Funkcja do pobierania dokumentów
  const apiEndpoint = useCallback(async () => {
    return await httpClient.get(
      "hrdocuments/category?category=benefits&subcategory=multisport",
      {
        withAuth: true,
      },
    );
  }, []);

  const apiEndpointWithDelete = useMemo(() => {
    const endpoint = apiEndpoint;
    endpoint.delete = async (id) => {
      return await httpClient.delete(`hrdocuments/${id}`, {
        withAuth: true,
      });
    };
    return endpoint;
  }, [apiEndpoint]);

  return (
    <BenefitDocumentsList
      apiEndpoint={apiEndpointWithDelete}
      sectionTitle={t("header.multisport")}
      createPath="/administrator/pliki/benefity/multisport/nowe-multisport"
      editPathPrefix="/administrator/pliki/benefity/multisport/edytuj/"
      isAdmin={isAdmin}
      getIconForSingleFile={getIconForSingleFile}
      downloadFile={downloadFile}
      API_URL={API_URL}
      userData={userData}
      deleteButtonIcon={deleteButtonIcon}
    />
  );
};

export default Multisport;
